<template>
  <div>
    <router-view v-show="$route.matched.length==3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length==2">
      <div class="main-page-content">
        <el-row class="table-header">
          <el-col>
            <el-button type="text" size="medium" @click="mxGoUrl(mxGetOssUrl('/sample/excel/服务费用确认函模板.docx', true))">
              下载服务费用确认函模板.docx
            </el-button>
            <el-button type="text" size="medium" @click="mxGoUrl(mxGetOssUrl('/sample/excel/服务费用结算清单模板.xls', true))">
              下载服务费用结算清单模板.xls
            </el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-form :inline="true" :model="searchCondition" class="demo-form-inline">
            <el-form-item label="">
              <el-radio-group size="medium" v-model="source" @change="changeSelc">
                  <el-radio-button label="saas">系统</el-radio-button>
                  <el-radio-button disabled label="openapi">开放平台</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="名称">
              <el-input v-model="searchCondition.channel_name" placeholder="输入任务名称" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="创建日期">
              <DatePicker @dataSearch="dataSearch"/>
            </el-form-item> -->
            <!-- <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item> -->
          </el-form>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane v-for="(item, index) in this.tabsList" :label="item.label" :key="index" :name="item.name" class="tab-item">
          </el-tab-pane>
          <ApeTable ref="apeTable" :data="dataList" :columns="columns" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" @selectList="selectList" highlight-current-row>
            <el-table-column
              slot="first-column"
              type="selection"
              >
            </el-table-column>
            <el-table-column
              slot="first-column"
              width="180"
              align="center"
              label="ID">
              <template slot-scope="scope">
                {{ scope.row.id }}
              </template>
            </el-table-column>
            <el-table-column
              slot="second-column"
              width="100"
              align="center"
              label="确认函">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.bill_file_url_two)" >
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.bill_file_url_two)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
            slot="second-column"
            width="100"
            align="center"
            label="结算清单">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="mxPreview(scope.row.bill_file_url)" >
                  <i class="iconfont iconwenjian iconbtn iconBtns"></i>
                </el-button>
                <el-button size="mini" type="text" @click="mxGoUrl(scope.row.bill_file_url)">
                  <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="bill_desc"
              label="拒绝原因"
              v-if="this.isRefuse">
              {{this.isRefuse}}
              <template slot-scope="scope">
                <div
                  :style="'color: #f56c6c'"
                >{{scope.row.bill_desc}}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="buttonType=='text'"
              width="200"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <span>
                  <el-button size="mini" @click="addButton(scope.row.id)"  v-show="userPermissions.indexOf('bill_upload') != -1 && scope.row.bill_status != 1 && scope.row.bill_status !=0">上传业务清单+</el-button>
                  <el-button size="mini" type="text" @click="mxGoUrl(scope.row.file_url)" v-show="scope.row.file_url">
                    <i class="iconfont iconxiazai iconbtn iconBtns"></i>
                  </el-button>
                </span>
              </template>
            </el-table-column>
          </ApeTable>
          <el-row>
            <el-col :span="24">
              <el-button size="medium" type="primary" class="check-upload" v-if="showBillBtn" :disabled="isAble" @click="uploadAllBill">批量上传业务清单</el-button>
            </el-col>
          </el-row>
        </el-tabs>
      </div>
    </PageHeaderLayout>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
         <el-form ref="billForm" :model="formData" :rules="rules" label-width="140px">
           <el-col :span="24" class="content-left">
              <el-form-item label="服务费用确认函" prop="file_url_two">
              <upload-file
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                @before_upload="beforeUpload"
                :title="'服务费用'"
                :multiple="'false'"
                :multiSelection="false"
                :dir="'bill'"
                :selectfiles="'importService'"
                :postfiles="'submitImportService'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
              </el-form-item>
            </el-col>
            <el-col :span="24" class="content-left">
              <el-form-item label="业务清单" prop="file_url">
              <upload-file
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                @before_upload="beforeUpload"
                :title="'业务清单'"
                :multiple="'false'"
                :multiSelection="false"
                :dir="'bill'"
                :selectfiles="'importExcel'"
                :postfiles="'submitImportExcel'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
              </el-form-item>
            </el-col>
          </el-form>
      </template>
    </ModalDialog>
  </div >
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ApeDrawer from '@/components/ApeDrawer'
import ApeUploader from '@/components/ApeUploader'
import ModalDialog from '@/components/ModalDialog'
import DatePicker from '@/components/DatePicker.vue'
import UploadFile from "@/components/UploadFile";
import { mapGetters } from 'vuex'

export default {
  components: {
    PageHeaderLayout,
    ApeDrawer,
    ApeTable,
    ApeUploader,
    ModalDialog,
    DatePicker,
    UploadFile
  },
  data() {
    return {
      isRefuse: false,
      tabsList: [
        {
          label: '等待用户上传',
          name: 'waiteUpload'
        },
        {
          label: '拒绝（需要重新上传）',
          name: 'noPass'
        },
        {
          label: '正在审核中',
          name: 'waiteChecked'
        },
        {
          label: '已审核通过',
          name: 'checked'
        },
      ],
      waiteCheckedList: [],
      waiteUploadList: [],
      checkedList: [],
      noPassList: [],
      activeName: 'waiteUpload',
      idList: [],//控制上传多个业务清单按钮的id
      isAble: true,//控制上传多个业务清单按钮是否可用
      title: '',
      dialogData:{
        visible: false,
        title: '',
        width: '45%',
        loading: true,
        modal: false,
        loading_text: '',
        isLoading: false
      },
      source: 'saas',
      // element的cascader的props值
      cascaderProps:{
        label:'display_name',
        value:'id',
      },
      searchCategory: [],
      // 搜索条件
      searchCondition:{
      },
      loadingStaus: false,
      columns: [
        {
          title: '任务名称',
          value: 'name',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '成功金额',
          value: [
            // {label:'总金额：', value:'total_amount'},
            // {label:'人员数：', value:'total_num'},
            {label:'成功金额：', value:'succeed_money'},
            {label:'成功人数：', value:'succeed_num'},
          ],
          header_align: 'center',
          align: 'center',
          width: 200
        },
        // {
        //   title: '任务描述',
        //   value: 'desc',
        // },
        {
          title: '提交时间',
          value: 'created_at',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '结算状态',
          value: 'alias_status',
          header_align: 'center',
          align: 'center',
        },
        {
          title: '审核状态',
          value: 'alias_bill_status',
          header_align: 'center',
          align: 'center',
          width: 150
        },
      ],
      // 表格列表数据
      dataList:[
      ],
      // 分页信息
      pagingData:{
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        total: 0
      },
      // 分页的offset,序号列使用
      offset:0,
      // 已上传文件列表
      uploadFileList:[],
      // 表单验证
      rules: {
        title: [
          {required: true, message: '输入标题', trigger: 'blur' },
        ],
        type: [
          {required: true, message: '选择类型', trigger: 'blur' },
        ],
        is_new_win: [
          {required: true, message: '选择打开发方式', trigger: 'blur' },
        ],
        is_show: [
          {required: true, message: '选择状态', trigger: 'blur' },
        ],
        image: [
          {required: true, message: '上传图片', trigger: 'blur', validator:this.apeUploaderVerify},
        ],
      },
      // 附件表单内容
      formData:{},
      // 附件添加表单验证
      dialogRules: {
        title: [{required: true, message: '输入标题', trigger: 'blur' }],
      },
      // 已上传附件列表
      attachmentUploadFileList:[],
      showBillBtn: true,
      isCheckBtn: false,//上传弹框确定按钮是否可用
    }
  },
  computed: {
    ...mapGetters(['userPermissions','buttonType'])
  },
  watch: {
    "$route.matched" : function(n,o) {
      console.log(o)
      if (n.length === 2) {
        this.init()
      }
    }
  },
  methods: {
     // 重置分页
    async resetPage() {
      this.$refs.apeTable.currentPage = 1
    },
    //点击tab切换
    async handleClick(tab) {
      if(tab.name == 'waiteUpload') {//等待用户上传
        if(this.searchCondition.bill_status || this.searchCondition.bill_status == 0) {
          delete this.searchCondition.bill_status
        }
        this.showBillBtn = true
        this.isRefuse = false
        this.init('waiteUpload')
      }else if(tab.name == 'waiteChecked') {//审核中
        this.searchCondition.bill_status = 0
        this.showBillBtn = false
        this.isRefuse = false
        this.init('waiteChecked')
      }else if(tab.name == 'noPass'){//审核不通过
        this.searchCondition.bill_status = 2
        this.showBillBtn = true
        this.isRefuse = true
        this.init('noPass')
      }else if(tab.name == 'checked') { //已审核
        this.searchCondition.bill_status = 1
        this.showBillBtn = false
        this.isRefuse = false
        this.init('checked')
      }
      this.resetPage()
    },
    //上传多选的业务清单
    uploadAllBill() {
      this.formData.batch_id = this.idList
      this.dialogData.visible = true
      this.dialogData.title = '业务清单'
    },
    //选中多选按钮
    async selectList(list) {
      list.forEach((item, index) => {
        this.idList.push(item.id)
        if(item.id != this.idList[index] ) {
          this.idList.splice(index, 1)
        }
      });
      //数组去重
      this.idList = [...new Set(this.idList)]
      if(list.length != 0) {
        this.isAble = false
      }else {
        this.isAble = true
      }
    },
    //切换系统
    changeSelc() {
      console.log(this.source, "saas")
    },
    // 搜索
    searchButton() {
      this.init('search')
    },
    // 切换页码操作
    async switchPaging(val) {
      if(val) {
        this.currentPage = val;
      } else {
        this.currentPage = 1
      }
      this.init()
    },
     // 响应添加按钮
    async addButton(id,name) {
      // 添加子权限，拼接的前缀
      if (name) {
        this.namePrefix = name+'_'
      }
      this.formData.batch_id = id
      this.dialogData.visible = true
      this.dialogData.title = '业务清单'
      // this.initForm()
    },
    // 初始化form，将添加，编辑共同数据抽取出来
    // async initForm() {
    //   this.dialogData.loading = false
    // },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id)
      this.$router.push(this.$route.path+'/'+id+'/view')
    },
    //上传文件前的回调
    beforeUpload(load_text) {
      console.log("load_text",load_text)
      this.dialogData.loading_text = load_text;
      this.dialogData.isLoading = true;
    },
     // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({url, filename, load_text, title}) {
      console.log("->上传成功....", url, filename, load_text, title);
      if(title == '业务清单') {
        this.formData.file_url = url
        this.formData.name = filename
      }else if(title == '服务费用'){
        this.formData.file_url_two = url
      }
      console.log(this.formData,"this.formData")
      this.dialogData.loading_text = load_text
      this.dialogData.loading = false
      this.dialogData.isLoading = false;
    },
    //获取选中日期的值
    // dataSearch(value) {
    //   this.searchCondition.time_value = value
    // },
    // 初始化列表
    async init(type) {
      this.loadingStaus=true
      let pagingInfo = this.$refs['apeTable'].getPagingInfo(type)
      if(type) {
        pagingInfo.current_page = 1
      }
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition,pagingInfo)
      let {list,pages}= await this.$api.getBillList(searchCondition)
      this.dataList = []
      this.$nextTick(() => {
        this.dataList = list
      })
      this.pagingData.total = pages.total
      this.offset = pages.offset
      this.loadingStaus=false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      // if (this.searchCondition.id) {
      //   condition.id = this.searchCondition.id
      // }
      // if (this.searchCondition.channel_name) {
      //   condition.name = this.searchCondition.channel_name
      // }
      if(this.searchCondition.bill_status || this.searchCondition.bill_status == 0) {
        condition.bill_status = this.searchCondition.bill_status
      }
      // if (this.searchCondition.time_value) {
      //   condition.start_time = this.searchCondition.time_value[0]
      //   condition.end_time = this.searchCondition.time_value[1]
      // }
      return condition
    },
    async formSubmit() {
      console.log("formData -> ", this.formData);
      try {
        let id = await this.$api.saveBill(this.formData)
        if (id) {
          this.$notify.success('保存成功！')
          this.init()
          this.dialogData.visible = false
        }
      } catch(err) {
        console.log('err is ->', err)
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      console.log("success")
      // 调用组件的数据验证方法
      this.$refs['billForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false
      this.dialogData.loading = true
      this.formData = {}
      this.attachmentUploadFileList = []
    },
    keyupSubmit(){
      document.onkeydown = () => {
        let _key=window.event.keyCode;
        if(_key === 13){
          this.searchButton()
        }
      }
    },
  },

  created() {
    this.keyupSubmit()
  },
  mounted() {

    this.init()
  },
}
</script>

<style lang="stylus" scoped>
  .el-button
    margin-right 4px
    margin-bottom 4px
  .el-button + .el-button
    margin-left: 0
  .table-header
    margin-bottom 12px
  .el-popover .el-checkbox-group .el-checkbox
    margin-left 0px
    margin-right 12px
  .table-right
    float right
  .changeBtn
    display: flex
    flex-direction: row
    width: 1110px
  .demo-form-inline
    padding-top: 20px
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
  .el-form--inline .el-form-item
    margin-right: 30px
  .check-upload
    margin-top: 20px
  // .table-search
  //   height: 36px
</style>






